/**
 * BlurredContent - Blurs content and overlays subscription CTA
 *
 * Used for content like Gallery where we want to show a preview
 * but blur it until user subscribes.
 */

import { useNavigate } from 'react-router-dom'
import { ReactNode } from 'react'

interface BlurredContentProps {
  children: ReactNode
  message?: string
  buttonText?: string
  buttonHref?: string
}

export function BlurredContent({
  children,
  message = 'Subscription required',
  buttonText = 'Get Subscription',
  buttonHref = '/subscription'
}: BlurredContentProps) {
  const navigate = useNavigate()

  return (
    <div className="relative min-h-screen">
      {/* Blurred content */}
      <div className="filter blur-xl pointer-events-none select-none">
        {children}
      </div>

      {/* Overlay with CTA */}
      <div className="absolute inset-0 flex items-center justify-center bg-black/40 backdrop-blur-lg">
        <div className="text-center max-w-md p-6">
          {/* Lock icon */}
          <div className="w-16 h-16 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>

          {/* Message */}
          <p className="text-white text-xl font-semibold mb-6 drop-shadow-lg">
            {message}
          </p>

          {/* CTA Button */}
          <button
            onClick={() => navigate(buttonHref)}
            className="px-8 py-3 bg-[#5c5b44] text-white rounded-lg font-medium hover:bg-[#5c5b44] transition-colors shadow-lg"
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  )
}
